import {DeleteRecordsConfirmationButton} from '@flexinet/ui-components';
import {I18n} from '@aws-amplify/core';
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {deleteRecord} from "../services/CustomerSubscriptionsService.ts";
import {useCustomerSubscriptionsSelection} from "../hooks/useCustomerSubscriptionsSelection.ts";
import {customerSubscriptionsQueryKeys} from "../hooks/customerSubscriptionsQueryKeys.ts";
import {notifyError, notifySuccess} from "../../../components/ServiceNotifications.tsx";

export const DeleteRecordButton = () => {
    const {selectedRecords, clearSelection} = useCustomerSubscriptionsSelection();
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: () => Promise.all(selectedRecords.map(record => deleteRecord(record.id))),
        onSuccess: () => {
            notifySuccess(I18n.get('Customer Subscription deleted'));
            clearSelection();
        },
        // A rejected delete used to fail silently; the rows stayed selected and nothing said why.
        onError: notifyError,
        onSettled: () => queryClient.invalidateQueries({queryKey: customerSubscriptionsQueryKeys.all}),
    });

    return (
        <DeleteRecordsConfirmationButton
            disabled={selectedRecords.length === 0}
            recordIdsLength={selectedRecords.length}
            handleConfirm={() => mutation.mutate()}
        />
    );
};
